import { render, staticRenderFns } from "./DisplayLogicConfiguration.vue?vue&type=template&id=9769a3b6"
import script from "./DisplayLogicConfiguration.vue?vue&type=script&lang=js"
export * from "./DisplayLogicConfiguration.vue?vue&type=script&lang=js"
import style0 from "./DisplayLogicConfiguration.vue?vue&type=style&index=0&id=9769a3b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports